import { Helpers } from '@engine/index';
import { t, getCurrentLang } from '../lib/i18n';
const present = value => value !== null && value !== undefined && value !== '';
const first = (...values) => values.find(present);
const text = value => present(value) ? String(value) : t('no_data');
const money = value => Number.isFinite(value) ? Helpers.formatMoney(value) : t('no_data');
const capture = (value, regex) => String(value || '').match(regex)?.[1]?.trim();
function legacyAmount(row, label) {
 const value = capture(row.name, new RegExp('\\|\\s*(?:' + label + '):\\s*([^|]+)', 'i'));
 const cleaned = value?.replace(/\s*⚠️\s*$/, '').trim();
 return cleaned && /^[-−+]?\d[\d\s.,]*(?:\s*NOK)?$/.test(cleaned) ? cleaned : null;
}
function projectNote(row) {
 let note = String(row.name || '').split('|').slice(1)
  .filter(part => !/^\s*(?:kostnader|koszty|salg|sprzedaż|netto):/i.test(part) || !legacyAmount({ name: ' | ' + part }, 'kostnader|koszty|salg|sprzedaż|netto')).join(' | ').trim();
 if (getCurrentLang() === 'pl') note = note.replace(/\bposteringer\b/g,'pozycje').replace(/\bfra (\d{4})\b/g,'z $1');
 else note = note.replace(/\bpozycje\b/g,'posteringer').replace(/\bz (\d{4})\b/g,'fra $1');
 return note;
}
function column(key,label,value) { return {key,label:t(label),value}; }
function accountingNumber(row) {
 if (present(row.transactionNo)) return text(row.transactionNo);
 // A voucher key explicitly tagged "no" contains the accounting transaction number.
 const number = capture(row.voucherId, /^\d{4}:no:[^:]+:([^:]+)$/);
 return text(number);
}
/** Only documented fields are displayed. Absent identifiers and amounts stay unknown. */
export function getFindingEvidenceColumns(ruleId,rows) {
 if (!rows?.length) return null;
 if (ruleId === 'high_6540') {
  const columns = [
   column('voucher','evidence_voucher',accountingNumber),
   column('stamp','evidence_stamp',row=>text(first(row.stampNo,capture(row.accName,/\bstempel\s+([^\s·]+)/i),!present(row.transactionNo)?capture(row.accName,/\bbilag\s+([^\s·]+)/i):null))),
   column('invoice','evidence_invoice',row=>text(first(row.invoiceNo,capture(row.accName,/\bfaktura\s+([^·]+)/i)))),
   column('date','evidence_date',row=>text(first(row.date,capture(row.accName,/\b(\d{4}-\d{2}-\d{2})\b/)))),
   column('account','account',row=>text(row.accNum)),
   column('description','evidence_description',row=>text(first(row.description,row.name,row.accName))),
   column('amount','evidence_amount',row=>money(first(row.ub,row.sum))),
  ];
  if (rows.some(row=>present(row.id))) columns.push(column('recordId','evidence_record_id',row=>text(row.id)));
  return columns;
 }
 if (ruleId === 'project_pnl_summary') {
  const columns = [
   column('project','evidence_project',row=>text(first(row.accName,row.projectKey,String(row.name||'').split('|')[0].trim()))),
   column('sales','evidence_assigned_sales',row=>Number.isFinite(row.sales)?money(row.sales):text(legacyAmount(row,'salg|sprzedaż'))),
   column('costs','evidence_assigned_costs',row=>Number.isFinite(row.costs)?money(row.costs):text(legacyAmount(row,'kostnader|koszty'))),
   column('net','evidence_assigned_net',row=>Number.isFinite(first(row.net,row.ub))?money(first(row.net,row.ub)):text(legacyAmount(row,'netto'))),
  ];
  if (rows.some(row=>present(first(row.projectId,row.id)))) columns.push(column('projectId','evidence_project_id',row=>text(first(row.projectId,row.id))));
  if (rows.some(row=>present(row.txCount))) columns.push(column('txCount','evidence_tx_count',row=>text(row.txCount)));
  if (rows.some(row=>projectNote(row))) columns.push(column('note','evidence_note',row=>projectNote(row)||t('no_data')));
  return columns;
 }
 if (ruleId === 'prosjektregnskap_terskel') return [
  column('type','evidence_entity_type',row=>{
   const prefix = String(row.name||'').match(/^(Prosjekt|Projekt|Kunde|Klient):\s*/i)?.[1]?.toLowerCase();
   return ['prosjekt','projekt'].includes(prefix)?t('prosjektregnskap_project')
    :['kunde','klient'].includes(prefix)?t('prosjektregnskap_customer'):t('no_data');
  }),
  column('name','evidence_entity_name',row=>text(first(row.accName,String(row.name||'').replace(/^(?:Prosjekt|Projekt|Kunde|Klient):\s*/i,'').replace(/\s*[—–]\s*[-−+]?\d[\d\s.,]*(?:\s*NOK)?\s*$/,'')))),
  column('sales','evidence_booked_sales',row=>money(first(row.ub,row.sum))),
 ];
 return null;
}
